import { render, staticRenderFns } from "./exhibition-activity-feedback.vue?vue&type=template&id=5fd64f95&scoped=true&"
import script from "./exhibition-activity-feedback.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd64f95",
  null
  
)

export default component.exports